import { AxiosRequestConfig, AxiosRequestHeaders } from "axios";

export type DATE_TYPE = string | Date | number;

export interface CustomAxiosRequestConfig<D = any>
  extends AxiosRequestConfig<D> {
  authRequired?: boolean;
  skipAuthRefresh?: boolean;
}

export interface CustomInternalAxiosRequestConfig<D = any>
  extends CustomAxiosRequestConfig<D> {
  headers: AxiosRequestHeaders;
}

// Helper type to ensure at least one property is required
export type RequireAtLeastOne<T, Keys extends keyof T = keyof T> = Pick<
  T,
  Exclude<keyof T, Keys>
> &
  {
    [K in Keys]-?: Required<Pick<T, K>> & Partial<Pick<T, Exclude<Keys, K>>>;
  }[Keys];

// Helper type to make specific properties required
export type RequireProperty<T, K extends keyof T> = T & Required<Pick<T, K>>;

// Helper type to make specific properties optional
export type OptionalProperty<T, K extends keyof T> = Omit<T, K> &
  Partial<Pick<T, K>>;

export type TABLE_HEADER_ITEM = {
  key: string;
  label: string;
  category?: string;
  alwaysDisplayed?: boolean;
  // For an array-valued cell (rendered as a comma-joined, truncated string
  // with the full list in a tooltip) — how many characters to show before
  // truncating. Defaults to 30 when omitted, matching prior behavior.
  arrayTruncateLength?: number;
} & RequireAtLeastOne<{
  position?: "left" | "right" | "center";
  width?: number;
  type?: "timestamp" | "checkbox";
  visible?: boolean;
}>;

export type TABLE_HEADER_ARRAY = Array<TABLE_HEADER_ITEM>;

export enum SORT_DIRECTION {
  ASCENDING = "ASCENDING",
  DESCENDING = "DESCENDING",
}

export type SELECT_OPTIONS = Array<{
  key: string | number;
  value: any;
  [key: string | number]: any;
}>;
